const apiPrefix = process.env.NEXT_PUBLIC_APP_NAME;

/**
 * Constructs a Next.js API route path
 *
 * @param pathname - The API route pathname (e.g., 'address/suggest-address-edq')
 * @returns The full API route path
 *
 * @deprecated This function is deprecated as part of a broader effort to move away from Next.js API routes
 * in favor of direct API proxy clients. However, it remains functional and should continue to be used
 * for existing API route calls until those routes are migrated. Do not create duplicate implementations
 * of this function.
 */
function getNextApiRoute(pathname: string) {
    // NOSONAR - deprecated function is still required for existing API routes
    return apiPrefix ? `/api/${apiPrefix}/${pathname}` : `/api/${pathname}`;
}

export { getNextApiRoute };
